import React from "react";
import "./index.css";
import tipImg from "../../../../../assets/design-revamp-company/company-epr/tip-img-explanation.svg";

const AllocateModal = ({ onClose }) => {
  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal-content-base">
        <div className="modal-qa" style={{ maxWidth: "600px" }}>
          <div className="modal-qa-title">Tip</div>
          <div className="modal-qa-content">
            <div className="modal-qa-texts">
              <p
                style={{
                  marginBottom: "34.8px",
                  fontSize: "12px",
                  color: "#09366B",
                }}
              >
                You need to direct the invoices to the relevant category. You
                can even remove an individual entry eg. if it was a corrected
                related to last year or the like, by opening the account line to
                show individual entries in the left column. In the right section
                your entries have been automatically loaded in the first three
                columns.
              </p>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={tipImg}
                width={413}
                height={493}
                alt="Categories and their examples"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllocateModal;
